import {API_DRIVER} from "../config/axios";

const getExpensesRequestUrl = (endpointUrl: string) => {
    return `/api/expenses${endpointUrl}`
}

export interface IExpense {
    id: string
    date: string
    created_at: string
    title: string
    category: string
    description: string
    price: number
}

export interface IExpensesResponse {
    total_pages: number
    count: number
    data: IExpense[]
}

export interface IExpenseCreateEdit {
    title: string
    category: string
    description: string
    price: number
    date: string
}

export interface IExpenseFilters {
    searchText?: string
    category?: string
    startDate?: string
    endDate?: string
}

const ExpenseService = {
    fetchExpenses: (page: number, size: number, filters?: IExpenseFilters) => {
        return API_DRIVER.get<IExpensesResponse>(getExpensesRequestUrl(""), {
            params: {
                limit: size,
                offset: page,
                search_text: filters?.searchText?.trim() || undefined,
                category: filters?.category?.trim() || undefined,
                start_date: filters?.startDate || undefined,
                end_date: filters?.endDate || undefined,
            }
        })
    },
    createExpense: (body: IExpenseCreateEdit) => {
        return API_DRIVER.post<IExpense>(getExpensesRequestUrl(""), body)
    },
    updateExpense: (id: string, body: IExpenseCreateEdit) => {
        return API_DRIVER.put<IExpense>(getExpensesRequestUrl(`/${id}`), body)
    },
    deleteExpense: (id: string) => {
        return API_DRIVER.delete(getExpensesRequestUrl(`/${id}`))
    },
    fetchExpenseCategories: () => {
        return API_DRIVER.get<string[]>(getExpensesRequestUrl("/categories"))
    }
}

export default ExpenseService
